<template>
  <div class="table-scroll-shell">
    <div v-if="showLeft" class="scroll-btn left" @click="scrollLeft">
      <LeftOutlined />
    </div>

    <div v-if="showRight" class="scroll-btn right" @click="scrollRight">
      <RightOutlined />
    </div>

    <div ref="containerRef" class="table-scroll">
      <slot />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import {useAntTableHorizontalScroll} from "@/components/Tables/TableScroll";
import {LeftOutlined, RightOutlined} from "@ant-design/icons-vue";

export default {
  name: 'TableHorizontalScrollShell',
  components: {
    LeftOutlined,
    RightOutlined
  },

  setup(props, { expose }) {
    const containerRef = ref(null);

    const {
      showLeft,
      showRight,
      scrollLeft,
      scrollRight,
      rebindScroll,
      updateScrollState,
    } = useAntTableHorizontalScroll(containerRef);

    expose({
      rebindScroll,
      updateScrollState,
    });

    return {
      containerRef,
      showLeft,
      showRight,
      scrollLeft,
      scrollRight,
    };
  },
};
</script>

<style>
  .table-scroll-shell {
    position: relative;
  }

  .scroll-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: #F0F0F0;
    padding: 8px;
    cursor: pointer;
    user-select: none;
  }

  .scroll-btn.left {
    left: 0;
    border-radius: 0 16px 16px 0;
  }

  .scroll-btn.right {
    right: 0;
    border-radius: 16px 0 0 16px;
  }
</style>